(() => {
  const container = document.querySelector("[data-studio-contact]");
  if (!container) return;

  const panel = container.querySelector("[data-studio-form-panel]");
  if (!panel) return;

  const studioName = container.querySelector("[data-studio-contact-name]");

  /* One form is shared by every studio card. Auto-fill its "Studio
     type" field (added in the Forms app admin) with the clicked
     studio's name; the field is hidden by a CSS rule keyed on the
     data-studio-type-field marker attribute. The form is
     React-controlled, so the value must go through the native setter
     and an input event for the app to register it in its state. */
  const setNativeValue = (input, value) => {
    const proto = input instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, "value").set.call(input, value);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const fillStudioField = (panel) => {
    const name = panel.dataset.studioFillValue;
    if (!name) return;
    const embed = panel.querySelector("shopify-forms-embed");
    const root = (embed && embed.shadowRoot) || panel;
    root.querySelectorAll("label").forEach((label) => {
      const text = label.textContent.trim().toLowerCase();
      if (text !== "studio type" && text !== "studio") return;
      const input = root.querySelector(`[id="${CSS.escape(label.htmlFor)}"]`);
      if (!input) return;
      if (input.value !== name) setNativeValue(input, name);
      const field = input.closest("div");
      if (field) field.setAttribute("data-studio-type-field", "");
    });
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-studio-contact-open]");
    if (!trigger) return;
    container.hidden = false;
    if (studioName) studioName.textContent = trigger.dataset.studioName || "";
    container.scrollIntoView({ behavior: "smooth", block: "start" });
    panel.dataset.studioFillValue = trigger.dataset.studioName || "";
    fillStudioField(panel);
    const embed = panel.querySelector("shopify-forms-embed");
    const fieldScope = embed && embed.shadowRoot ? embed.shadowRoot : panel;
    const firstField = fieldScope.querySelector("input:not([type='hidden']), textarea");
    if (firstField) firstField.focus({ preventScroll: true });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:block:select", (event) => {
      if (event.target.closest("[data-studio-form-panel]")) container.hidden = false;
    });
  }

  /* --------------------------------------------------------------
     Shopify Forms app restyle, injected into the embed's shadow root.
     The app's own stylesheet is authored in rem assuming 1rem = 16px,
     but the theme sets html font-size to 62.5% (1rem = 10px), which
     collapses the floating-label geometry so labels overlap typed
     values. Theme CSS can't reach inside the shadow root, so these
     rules are appended to it here: floating labels become static
     uppercase eyebrows and all geometry is fixed in px. !important is
     required to beat the app's adoptedStyleSheets.
  -------------------------------------------------------------- */
  const FORMS_EMBED_CSS = `
    label {
      position: static !important;
      transform: none !important;
      transition: none !important;
      display: block !important;
      font-family: "Manrope", sans-serif !important;
      font-size: 10px !important;
      font-weight: 500 !important;
      letter-spacing: 0.24em !important;
      text-transform: uppercase !important;
      line-height: 1 !important;
      color: #806b4e !important;
      margin: 0 0 8px !important;
      padding: 0 !important;
    }

    div:has(> label):has(> input, > textarea, > select) {
      display: flex !important;
      flex-direction: column !important;
    }

    div:has(> label) > label {
      order: -1;
    }

    input:not([type="checkbox"]):not([type="radio"]),
    textarea,
    select {
      -webkit-appearance: none;
      appearance: none;
      width: 100% !important;
      box-sizing: border-box !important;
      background: #fff !important;
      border: 1px solid rgba(23, 24, 22, 0.18) !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: "Manrope", sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: normal !important;
      color: #11120f !important;
      transition: border-color 0.25s, box-shadow 0.25s !important;
    }

    input:not([type="checkbox"]):not([type="radio"]),
    select {
      height: 54px !important;
      padding: 0 16px !important;
    }

    textarea {
      min-height: 140px !important;
      padding: 14px 16px !important;
      resize: vertical !important;
    }

    input:focus,
    textarea:focus,
    select:focus {
      outline: none !important;
      border-color: #b09165 !important;
      box-shadow: 0 0 0 1px #b09165 !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: #9a948a !important;
      opacity: 1 !important;
    }

    form > * + * {
      margin-top: 18px !important;
    }

    button,
    [type="submit"] {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      width: 100% !important;
      min-height: 50px !important;
      height: 50px !important;
      padding: 0 24px !important;
      background: #11120f !important;
      color: #f1ede5 !important;
      border: none !important;
      outline: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: "Manrope", sans-serif !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      letter-spacing: 0.18em !important;
      text-transform: uppercase !important;
      line-height: normal !important;
      cursor: pointer !important;
      transition: 0.25s !important;
    }

    button:hover,
    [type="submit"]:hover {
      background: #b09165 !important;
      color: #111 !important;
    }

    button:focus-visible,
    [type="submit"]:focus-visible {
      outline: 2px solid #b09165 !important;
      outline-offset: 2px !important;
    }

    p {
      font-family: "Manrope", sans-serif !important;
      font-size: 11px !important;
      line-height: 1.7 !important;
      color: #625e57 !important;
    }

    p a {
      color: #7a6a52 !important;
      text-decoration: underline !important;
      text-underline-offset: 2px;
    }

    /* the app paints a white strip over textarea tops to mask scroll
       under its floating label; with static labels it just covers the
       label, so remove it */
    div:has(> textarea)::before {
      content: none !important;
    }

    output {
      font-family: "Manrope", sans-serif !important;
      font-size: 11px !important;
    }

    /* the "Studio type" field is filled by the theme with the clicked
       studio's name; customers never interact with it */
    [data-studio-type-field] {
      display: none !important;
    }
  `;

  const STYLE_MARKER = "data-studio-forms-style";

  const styleEmbed = (embed) => {
    const root = embed.shadowRoot;
    if (!root) return false;
    if (!root.querySelector(`style[${STYLE_MARKER}]`)) {
      const style = document.createElement("style");
      style.setAttribute(STYLE_MARKER, "");
      style.textContent = FORMS_EMBED_CSS;
      root.appendChild(style);
    }
    if (!embed.dataset.studioFormsObserved) {
      embed.dataset.studioFormsObserved = "true";
      // The app may re-render the shadow root's contents; re-append the
      // style element (and re-fill the Studio field) whenever it changes.
      new MutationObserver(() => {
        styleEmbed(embed);
        const panel = embed.closest("[data-studio-form-panel]");
        if (panel) fillStudioField(panel);
      }).observe(root, { childList: true, subtree: true });
    }
    return true;
  };

  const styleAllEmbeds = () => {
    container.querySelectorAll("shopify-forms-embed").forEach(styleEmbed);
  };

  // The server-rendered embed elements fail their first upgrade (the
  // app's loader constructor throws before index.js has set
  // window.formStyles), and the app later swaps in fresh nodes — so a
  // one-shot pass isn't enough. Restyle on definition/upgrade and on
  // any DOM change inside the container (catches node replacement and
  // late renders).
  styleAllEmbeds();
  if (window.customElements) {
    customElements.whenDefined("shopify-forms-embed").then(styleAllEmbeds);
  }
  new MutationObserver(styleAllEmbeds).observe(container, {
    childList: true,
    subtree: true,
  });
})();
